import { attr, belongsTo } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const ShootingSchedule = ApplicationRecord.extend({
  static: {
    jsonapiType: 'shooting_schedules',
  },
  attrs: {
    schoolId: attr(),
    appointmentsPerBlock: attr(),
    shootingDay: attr(),
    startTime: attr(),
    endTime: attr(),
    availableTimeslots: attr(),
    school: belongsTo(),
  },
})

export default ShootingSchedule
